module.exports = __webpack_public_path__ + "static/media/profile_pack1.d7c2fdc5.png";